export default __webpack_public_path__ + "static/media/logo.54b09a6c.svg";